import { useQueryClient } from '@tanstack/react-query';
import { useCurrentProject } from '@modules/projects/utils/useCurrentProject';
import { useBudgetItemsQuery, useReorderBudgetItemMutation, useReorderCostItemEntryMutation, useReorderCostItemMutation } from 'gql/index';
import { graphql } from 'gql/gql';

graphql(`
  mutation reorderBudgetItem($input: ReorderBudgetItemInput!) {
    reorderBudgetItem(input: $input) {
      errors {
        ... on Error { message }
      }
    }
  }
`);

graphql(`
  mutation reorderCostItem($input: ReorderCostItemInput!) {
    reorderCostItem(input: $input) {
      errors {
        ... on Error { message }
      }
    }
  }
`);

graphql(`
  mutation reorderCostItemEntry($input: ReorderCostItemEntryInput!) {
    reorderCostItemEntry(input: $input) {
      errors {
        ... on Error { message }
      }
    }
  }
`);

export const useBudgetReorderMutations = () => {
  const { projectId } = useCurrentProject();
  const queryClient = useQueryClient();
  const budgetItemsKey = useBudgetItemsQuery.getKey({ projectId });

  const reorderBudgetItem = useReorderBudgetItemMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: budgetItemsKey });
    }
  });

  const reorderCostItem = useReorderCostItemMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: budgetItemsKey });
    }
  });

  const reorderCostItemEntry = useReorderCostItemEntryMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: budgetItemsKey });
    }
  });

  return {
    reorderBudgetItem,
    reorderCostItem,
    reorderCostItemEntry,
  };
};
